'use client';
import { CatInputField } from '@blocks-react/components/InputField';
import { BlocksChangeEvent } from '@blocks-web-components/events';
import { MyEquipmentNicknameProps } from '../types';
import { useFormContext } from 'react-hook-form';
import { useInputController } from './../../../hooks/form-controllers/useInputController/useInputController';

export const MyEquipmentNickname = (props: MyEquipmentNicknameProps) => {
  const {
    name,
    rules = {},
    isError,
    placeholder,
    fieldNote,
    onChange: onInputChange
  } = props;
  const { setValue, getValues } = useFormContext();
  const { inputField, field } = useInputController({ name, rules });
  const { isError: fieldError, fieldNote: fieldErrorMessage } = inputField;
  const error = !!(isError ?? fieldError);
  const note = fieldNote ?? fieldErrorMessage;
  const nickName = getValues(name);

  const onBlChange = (e: BlocksChangeEvent): void => {
    const inputValue = e.detail.value;
    if (nickName !== inputValue) {
      if (onInputChange) {
        onInputChange(inputValue);
      }
      setValue(name, inputValue);
      field.onChange(e);
    }
  };

  return (
    <CatInputField
      {...inputField}
      hideLabel
      type="text"
      placeholder={placeholder}
      data-testid={props.name}
      value={nickName}
      fieldNote={note}
      status={error ? 'error' : undefined}
      name={name}
      onBlChange={onBlChange}
    />
  );
};
